objectsToMerge